import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, Fx } from 'Components';
import styles from '../Dashboard.module.scss';
import {
	useDashboardFilters,
	DashboardFiltersProps
} from './DashboardFilters.hooks';
import DashboardGroupFilter from './filters/DashboardGroupFilter';
import { useDashboardContext } from '../DashboardContext';

function DashboardFilters(props: DashboardFiltersProps) {
	const [disableCheckbox, setDisableCheckbox] = useState(false);
	const { t } = useTranslation();
	const { showFilter = true } = props;
	const { filters } = useDashboardContext();

	const {
		submitting,
		isPropertyCheckboxVisible,
		isPropertiesOnly,
		onGroupsChange,
		onPropertyChange
	} = useDashboardFilters(props);

	useEffect(() => {
        if(!filters?.id && filters?.isProperty) {
			const element = document.getElementById("properties-checkbox");
			if(element) {
				element.click();
				setDisableCheckbox(false);
			}
		} else setDisableCheckbox(!(filters?.id || 0));
    }, [filters])

	return (
		<Fx className={styles.filters} align="middle" style={{ display: showFilter ? "flex" : "none"}}>
			<DashboardGroupFilter
				horizontal
				onChange={onGroupsChange}
				submitting={submitting}
				propertiesOnly={isPropertiesOnly}
			/>

			<Fx className={styles.suffixField}>
				{isPropertyCheckboxVisible && (
					<Checkbox id="properties-checkbox" disabled={submitting || disableCheckbox} onChange={onPropertyChange}>
						{t('dashboard.filters.properties.label')}
					</Checkbox>
				)}
			</Fx>
		</Fx>
	);
}

export default DashboardFilters;
